import { jsx as _jsx } from "react/jsx-runtime";
import Legal from '~components/legal';
const ProofOfValueAgreement = () => _jsx(Legal, { id: "proof-of-value-agreement" });
export default ProofOfValueAgreement;
